module.exports = __webpack_public_path__ + "img/palomita.753c4e0b.svg";